import React from 'react'
import { Header3 } from './Type'
import { SingleStatCard } from './Cards'

// Define interfaces for the component props
interface Stat {
  name: string;
  value: number | string;
}

interface SimpleStatsProps {
  title: string;
  stats: Stat[];
}

export const SimpleStats: React.FC<SimpleStatsProps> = ({ title, stats }) => {
  return (
    <div className='mb-4'>
      <Header3 title={title} />
      <dl className='mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3'>
        {stats.map(stat => (
          <SingleStatCard
            key={stat.name}
            stat={stat.value}
            label={stat.name}
          />
        ))}
      </dl>
    </div>
  )
}
